import script from "./SolutionsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SolutionsPage.vue?vue&type=script&setup=true&lang=js"

import "./SolutionsPage.vue?vue&type=style&index=0&id=73c38ef2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73c38ef2"]])

export default __exports__